import useCurrentResourceCentre from "./useCurrentResourceCentre";

function UseHasLeadClientEnabled(): { isLeadClientEnabled: boolean } {
  const rc = useCurrentResourceCentre();
  return { isLeadClientEnabled: rc?.settings?.clientSettings?.enableLeadClients ?? false };
}

export default UseHasLeadClientEnabled;
